import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="#313131"
    {...props}
  >
    <path d="M4 22H20C21.1046 22 22 21.1046 22 20V8.62597L14.3961 2.44777C14.0396 2.15811 13.5942 2 13.1349 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22ZM23 8.15L15.0267 1.67166C14.4919 1.23717 13.8239 1 13.1349 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V8.15Z" />
    <path d="M17 13.5C17 13.2239 16.7761 13 16.5 13H7.5C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14L16.5 14C16.7761 14 17 13.7761 17 13.5ZM17 9.5C17 9.22386 16.7761 9 16.5 9H7.5C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10H16.5C16.7761 10 17 9.77614 17 9.5Z" />
    <path d="M12 17.5C12 17.2239 11.7761 17 11.5 17H7.5C7.22386 17 7 17.2239 7 17.5C7 17.7761 7.22386 18 7.5 18H11.5C11.7761 18 12 17.7761 12 17.5Z" />
  </svg>
);
